import * as map90030 from './originalBoards/bugmaker-90030.json';
import * as map90029 from './originalBoards/bugmaker-90029.json';
import * as map90004 from './originalBoards/duule-90004.json';
import * as map90011 from './originalBoards/nbdragon-90011.json';
import * as map90015 from './originalBoards/qierkang-90015.json';

export interface OriginalBoardPattern {
  id: string; name: string; levelKey: number; source: string; license: string;
  snapshotSha256: string; shapeSha256: string; groups: number[][];
  /** Source x, y, layer, mold. A source card is exactly 8 × 8 units. */
  nodes: number[][];
}
/** Append only; saved layoutId is the stable identity, index controls rotation. */
export const BOARD_PATTERNS: OriginalBoardPattern[] = [map90030, map90029, map90004, map90011, map90015];
export const WORLD_STAGE_NOTE = '无固定总关数 · ' + BOARD_PATTERNS.length + '种牌型循环';
export const REFERENCE_PATTERN_NAMES = ['层叠菱城', '十字大城', '工字叠城', '回字环城', '蝶翼交错', '双L连桥', '井字天桥', '八角叠台', '旋转楼梯', '双工交错', '三角阶梯', '花瓣叠城'];
export const normalizePatternIndex = (index: number): number =>
  ((Math.floor(Number.isFinite(index) ? index : 0) % BOARD_PATTERNS.length) + BOARD_PATTERNS.length) % BOARD_PATTERNS.length;
export const resolvePatternIndex = (index: number, id?: string): number => {
  const saved = BOARD_PATTERNS.findIndex(pattern => pattern.id === id);
  return saved >= 0 ? saved : normalizePatternIndex(index);
};
